export const condeyModes = {
    auto: 'auto',
    cool: 'cool',
    dry: 'dry',
    heat: 'heat',
    vent: 'vent',
}

export const condeyFlow = {
    vert: 'vert_on',
    horizont: 'horizont_on',
    all: '3d_on',
    off: 'off',
}

// export const condeyFanSpeed = {
//     min: 'min',
//     mid: 'mid',
//     max: 'max',
//     auto: 'auto',
// }
export const condeyFanSpeed = {
    min: '1',
    mid: '2',
    max: '3',
    auto: '0',
}

export const connectionState = {
    online: 'connected',
    offline: 'disconnected',
}

export const condeyModesLang = {
    [condeyModes.cool]: 'Охлаждение',
    [condeyModes.heat]: 'Обогрев',
    [condeyModes.dry]: 'Осушение',
    [condeyModes.vent]: 'Вентиляция',
    [condeyModes.auto]: 'Автоматический',
}
export const condeyFlowLang = {
    [condeyFlow.horizont]: 'Горизонтальный',
    [condeyFlow.vert]: 'Вертикальный',
    // [condeyFlow.all]: 'Все направления',
    [condeyFlow.all]: '',
    // [condeyFlow.off]: 'Выключен',
}
export const condeyFanSpeedLang = {
    [condeyFanSpeed.min]: 'Минимальный',
    [condeyFanSpeed.mid]: 'Средный',
    [condeyFanSpeed.max]: 'Максимальный',
    [condeyFanSpeed.auto]: 'Автоматический',
}

export const onOffLang = {
    on: 'вкл',
    off: 'выкл',
}

export const condeyBrands = {
    Daikin: 'Daikin',
    Midea: 'Midea',
    Kentatsu: 'Kentatsu',
    Daichi: 'Daichi',
}

export const condeyTempLimits = {
    [condeyBrands.Daichi]:{
        min: 17,
        max: 30,
    },
    [condeyBrands.Midea]:{
        min: 17,
        max: 30,
    },
    [condeyBrands.Kentatsu]:{
        min: 17,
        max: 30,
    },
    [condeyBrands.Daikin]:{
        min: 18,
        max: 32,
    },
}


